import { render, staticRenderFns } from "./Ccl.vue?vue&type=template&id=2fbd135a&scoped=true&"
import script from "./Ccl.vue?vue&type=script&lang=js&"
export * from "./Ccl.vue?vue&type=script&lang=js&"
import style0 from "./Ccl.vue?vue&type=style&index=0&id=2fbd135a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd135a",
  null
  
)

export default component.exports